module.exports = __webpack_public_path__ + "static/babel.529bf9cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devicon/babel.svg
// module id = 1156
// module chunks = 263791100135453